import i18n from '@/app/i18n/config';
import { useSettingsStore } from '@/stores/settings.store';

const LANGUAGE_STORAGE_KEY = 'i18nextLng';

/**
 * Aplica idioma y moneda guardados del usuario (desde perfil o caché).
 * Usado en login, registro y al cargar la app con sesión.
 */
export async function applyUserPreferences(
  preferredLanguage?: string | null,
  preferredCurrency?: string | null,
): Promise<void> {
  if (preferredLanguage && ['es', 'en'].includes(preferredLanguage)) {
    await i18n.changeLanguage(preferredLanguage);
    if (typeof window !== 'undefined') {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, preferredLanguage);
    }
  }
  if (preferredCurrency && ['USD', 'COP', 'MXN'].includes(preferredCurrency)) {
    useSettingsStore.getState().setCurrency(preferredCurrency as 'USD' | 'COP' | 'MXN');
  }
}
